module.exports = __webpack_public_path__ + "static/media/carousel-02.b2b8a881.jpg";